import React from "react";
import Input from "@material-ui/core/Input";
import InputLabel from "@material-ui/core/InputLabel";
import MenuItem from "@material-ui/core/MenuItem";
import FormControl from "@material-ui/core/FormControl";
import ListItemText from "@material-ui/core/ListItemText";
import ListItemIcon from "@material-ui/core/ListItemIcon";
import Select from "@material-ui/core/Select";
import Checkbox from "@material-ui/core/Checkbox";
import useStyles from "./styles";

const ITEM_HEIGHT = 48;
const ITEM_PADDING_TOP = 8;
const MenuProps = {
  PaperProps: {
    style: {
      maxHeight: ITEM_HEIGHT * 4.5 + ITEM_PADDING_TOP,
      width: 280,
    },
  },
};

export default function MultiSelectCategory({
  selectedIds,
  List,
  setFieldValue,
  name,
  heading,
  setCategoryId,
  trades,
}) {
  const classes = useStyles();
  const category = List?.map((result) => result.map((result) => result));
  const categories = category?.flat();

  const key = "id";
  const categoryList = [
    ...new Map(categories.map((item) => [item[key], item])).values(),
  ];
  // console.log("categoryList", categoryList);
  // console.log("trades", trades);
  // const result = categoryList.filter(item => trades.includes(item.id))
  // console.log("result==>", result)

  const isAllSelected = List.length > 0 && selectedIds.length === List.length;

  const handleChange = (e) => {
    const value = e.target.value;
    // console.log("value", value)
    if (value[value.length - 1] === "all") {
      setFieldValue(
        name,
        selectedIds.length === categoryList.length
          ? []
          : categoryList.map((category) => category.id)
      );
      setCategoryId(categoryList.map((category) => category.id));
      return;
    }
    setFieldValue(name, value);
    setCategoryId(value);
  };

  return (
    <div style={{ display: "inline-block", marginTop: "4%" }}>
      <FormControl className={classes.formControl} variant="outlined">
        <InputLabel id="demo-mutiple-checkbox-label" className="form-label">
          {heading}
          <span className="required">&#42;</span>
        </InputLabel>
        <Select
          labelId="demo-mutiple-checkbox-label"
          id="demo-mutiple-checkbox"
          multiple
          value={selectedIds}
          onChange={handleChange}
          input={<Input />}
          renderValue={(selected) =>
            categoryList
              ?.filter((category) => selected.includes(category.id))
              .map((category) => category.name)
              .join(", ")
          }
          MenuProps={MenuProps}
        >
          {categoryList.length > 1 && (
            <MenuItem
              value="all"
              classes={{
                root: isAllSelected ? classes.selectedAll : "",
              }}
            >
              <ListItemIcon>
                <Checkbox
                  classes={{ indeterminate: classes.indeterminateColor }}
                  checked={isAllSelected}
                  indeterminate={
                    selectedIds.length > 0 &&
                    selectedIds.length < categoryList.length
                  }
                />
              </ListItemIcon>
              <ListItemText
                classes={{ primary: classes.selectAllText }}
                primary="Select All"
              />
            </MenuItem>
          )}

          {categoryList.map((category) => (
            <MenuItem key={category._id} value={category.id}>
              <Checkbox checked={selectedIds.indexOf(category.id) > -1} />
              <ListItemText primary={category.name} />
            </MenuItem>
          ))}
        </Select>
      </FormControl>
    </div>
  );
}
